export const REGISTER_SUPPLIER = "REGISTER_SUPPLIER";
export const GET_SUPPLIERS = "GET_SUPPLIERS";
export const GET_SUPPLIER_BY_ID = "GET_SUPPLIER_BY_ID";
export const SET_SUPPLIER_TO_NULL = "SET_SUPPLIER_TO_NULL";
